import { StructureBlockIndex } from '@morph-mapper/node-logic';
import { useMapEntryContext, useTreeContext } from '../../context';
import { useNavigate } from 'react-router';
import { useStore } from '@/store';

export const useMapRow = () => {
  /* Context State */
  const moveIn = useTreeContext((s) => s.moveIn);
  const [
    id,
    outputType,
    setOutputType,
    getFormerOutputType,
    setFormerOutputType,
  ] = useMapEntryContext((s) => [
    s.getId(),
    s.getOutputType(),
    s.setOutputType,
    s.getFormerOutputType(),
    s.setFormerOutputType,
  ]);
  const templateId = useStore(({ config: c }) => c.getId());
  /* Hooks */
  const navigate = useNavigate();
  /**
   * Handlers
   **/
  const handleConfigureEntry = () => {
    if (outputType === 'code') {
      navigate(`/${templateId}/entries/${id}/code`);
    } else {
      navigate(`/${templateId}/entries/${id}/context`);
    }
  };

  const handleFocusChange = () => {
    moveIn(id);
  };

  const handleTypeChange = (isCode: boolean) => {
    const former = getFormerOutputType;
    const current = outputType;
    setFormerOutputType(current);

    if (current === 'code') {
      setOutputType(former);
    } else if (isCode) {
      setOutputType('code');
    }
  };

  return {
    handleTypeChange,
    handleConfigureEntry,
    handleFocusChange,
  };
};
